import React from 'react';
import { Row, Col, Text, Div } from 'atomize';
import { FooterContainer, LinkChild } from './FooterElements';

const Footer = () => {
    return (
        <FooterContainer>
            <div>
                <Row
                    flexDir={{ xs: 'column', lg: 'row' }}
                    align="center"
                    p={{t:"1rem"}}
                >
                    <Col
                        w="16rem"
                        align="center"
                    >
                        <Row
                            style={{
                                paddingTop: '.25rem',
                                justifyContent: 'center'
                            }}
                        >
                            <a
                                href="https://www.norrisacademywi.org" // Added https:// to the URL
                                target="_blank"
                                rel="noopener noreferrer" // Optional, for security and performance
                                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} // Added inline styles for centering
                            >
                                <Div
                                    justify="center"
                                    align="center"
                                    h="6.25rem"
                                    w="7rem"
                                    bgImg={require('../../images/footerlogo.png')}
                                    bgSize="cover"
                                    bgPos="center center"
                                />                        
                            </a>
                        </Row>
                        <Text
                            textColor="white"
                            textAlign="center"
                            textSize="paragraph"
                            textWeight="500"
                            p={{t:"1rem"}}
                            style={{opacity: 0.95}}
                        >
                            @NorrisConnects26
                        </Text>
                    </Col>
                </Row>
            </div>
        </FooterContainer>
    )
}

export default Footer;